module.exports = __webpack_public_path__ + "img/responsive crc-07.c50b024b.jpg";